<template>
  <div class="pushRequestContainer">
    <button class="prompt" @click="requestPushNotificationPermission" title="Enable notifications">
      {{ message }}
    </button>
    <button class="close" @click="dismissBanner" title="Dismiss this banner" v-if="showClose">
      <BrandIcon name="special/dismiss" class="icon" />
    </button>
  </div>
</template>

<script setup lang='ts'>
import { computed, ComputedRef } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { AppName } from '@/data/Branding';
import { usePushNotificationStore } from '@/stores/PushNotification';

const pushNotificationStore = usePushNotificationStore();

interface Props {
  showClose?: boolean;
}
withDefaults(defineProps<Props>(), {
  showClose: true,
});

const message: ComputedRef<string> = computed(() => {
  return `${AppName} needs your permission to enable notifications on this device`;
});

function requestPushNotificationPermission(): void {
  pushNotificationStore.requestPushNotificationPermission();
}

function dismissBanner(): void {
  // Flag in local storage that the user dismissed the banner so we don't annoy them each time they reload
  pushNotificationStore.setBannerDismissed(true);
}
</script>

<style lang="scss" scoped>
.pushRequestContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $colour-background-emphasis;

  button {
    color: $colour-text-contrast;

    &.prompt {
      padding: 0 0.5rem;
    }

    &.close {
      padding-left: 0.5rem;
    }
  }
}
</style>
